/* kn-flags-menu.js · PixelNova Solutions · 10/8/2026
   Added: shared disclosure styling/controls for Ella's cloned mobile menu. */
(() => {
  if (window.knFlagsMenuLoaded) return;
  window.knFlagsMenuLoaded = true;
  const desktop = window.matchMedia('(min-width:1025px)');
  const rootSelector = '.kn-flags-nav, .kn-mobile-nav';
  const triggerSelector = '.kn-flags-trigger, .kn-mobile-trigger';
  const panelSelector = '.kn-flags-panel, .kn-mobile-panel';
  const roots = () => document.querySelectorAll(rootSelector);
  const ids = new WeakMap();
  let sequence = 0;
  const open = (root, expanded) => {
    const trigger = root.querySelector(triggerSelector);
    const panel = root.querySelector(panelSelector);
    if (!trigger || !panel) return;
    if (!ids.has(root)) ids.set(root, `kn-flags-panel-${++sequence}`);
    panel.id = ids.get(root);
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
  };
  const closeAll = (except) => roots().forEach(root => { if (root !== except) open(root, false); });
  const label = text => {
    const clean = text.trim().replace(/\s+/g, ' ');
    return clean === clean.toUpperCase() ? clean.toLowerCase().replace(/\b[a-z]/g, char => char.toUpperCase()) : clean;
  };
  const enhanceMobile = () => {
    if (desktop.matches) return;
    document.querySelectorAll('#navigation-mobile .menu-lv-1.dropdown:not(.kn-mobile-nav):not(.kn-flags-nav)').forEach(root => {
      const original = root.querySelector(':scope > a');
      const submenu = root.querySelector(':scope > .header__submenu, :scope > .menu-dropdown');
      if (!original || !submenu) return;
      const links = [...submenu.querySelectorAll('a[href]')].filter(a => a.getAttribute('href') !== '#');
      if (!links.length) return;
      root.classList.add('kn-mobile-nav');
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'kn-mobile-trigger';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.append(document.createTextNode(original.querySelector('.text')?.textContent.trim() || original.textContent.trim()));
      const caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      caret.setAttribute('viewBox', '0 0 16 16');
      caret.setAttribute('class', 'kn-mobile-caret');
      caret.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'm4 6 4 4 4-4');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.6');
      caret.append(path);
      trigger.append(caret);
      const panel = document.createElement('div');
      panel.className = 'kn-mobile-panel';
      panel.hidden = true;
      const list = document.createElement('ul');
      list.className = 'kn-mobile-list';
      panel.append(list);
      links.forEach(source => {
        const link = document.createElement('a');
        link.href = source.getAttribute('href');
        link.className = 'kn-mobile-link';
        if (source.hasAttribute('aria-current')) link.setAttribute('aria-current', source.getAttribute('aria-current'));
        const text = document.createElement('span');
        const sourceLabel = source.querySelector('.text')?.textContent || source.textContent;
        const parentLabel = original.querySelector('.text')?.textContent.trim() || original.textContent.trim();
        text.textContent = label(sourceLabel.replace(parentLabel, label(parentLabel)));
        const arrow = document.createElement('span');
        arrow.className = 'kn-mobile-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        link.append(text, arrow);
        if (source.closest('.navigation_all_mobile')) {
          const footer = document.createElement('div');
          footer.className = 'kn-mobile-foot';
          footer.append(link);
          panel.append(footer);
        } else {
          const item = document.createElement('li');
          item.append(link);
          list.append(item);
        }
      });
      root.append(trigger, panel);
      open(root, false);
    });
  };
  enhanceMobile();
  new MutationObserver(enhanceMobile).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', event => {
    const trigger = event.target.closest(triggerSelector);
    if (trigger) {
      const root = trigger.closest(rootSelector);
      const expanded = desktop.matches && event.detail > 0 ? true : trigger.getAttribute('aria-expanded') !== 'true';
      closeAll(root);
      open(root, expanded);
    } else if (!event.target.closest(rootSelector) || event.target.closest('.kn-flags-panel a, .kn-mobile-panel a')) {
      closeAll();
    }
  });
  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    const root = event.target.closest(rootSelector);
    if (!root && event.target.closest('.menu-lv-1')) { closeAll(); return; }
    if (root && !root.contains(event.relatedTarget)) { closeAll(root); open(root, true); }
  });
  document.addEventListener('pointerout', event => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    const root = event.target.closest(rootSelector);
    if (root && !root.contains(event.relatedTarget) && !root.contains(document.activeElement)) open(root, false);
  });
  document.addEventListener('focusout', event => {
    if (!desktop.matches) return;
    const root = event.target.closest(rootSelector);
    if (root && !root.contains(event.relatedTarget)) open(root, false);
  });
  document.addEventListener('keydown', event => {
    const root = event.target.closest(rootSelector);
    if (!root) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      open(root, false);
      root.querySelector(triggerSelector).focus();
    } else if (event.key === 'ArrowDown' && event.target.matches(triggerSelector)) {
      event.preventDefault();
      closeAll(root);
      open(root, true);
      root.querySelector(panelSelector).querySelector('a').focus();
    }
  });
  desktop.addEventListener('change', () => { enhanceMobile(); closeAll(); });
  document.addEventListener('shopify:section:unload', () => closeAll());
})();
